import * as React from 'react';

const AttachmentIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.47 7.5L7.65994 15.4398C7.37863 15.7211 7.2206 16.1026 7.2206 16.5005C7.2206 16.8983 7.37863 17.2798 7.65994 17.5611C7.94124 17.8424 8.32277 18.0005 8.7206 18.0005C9.11842 18.0005 9.49995 17.8424 9.78126 17.5611L19.0914 8.12132C19.3699 7.84274 19.5909 7.51203 19.7417 7.14805C19.8924 6.78407 19.97 6.39397 19.97 6C19.97 5.60603 19.8925 5.21593 19.7417 4.85195C19.5909 4.48797 19.3699 4.15726 19.0914 3.87868C18.8128 3.6001 18.4821 3.37913 18.1181 3.22836C17.7541 3.0776 17.364 3 16.97 3C16.5761 3 16.186 3.0776 15.822 3.22836C15.458 3.37913 15.1273 3.6001 14.8487 3.87868L5.53862 13.3185C4.6947 14.1624 4.2206 15.307 4.2206 16.5005C4.2206 17.6939 4.6947 18.8385 5.53862 19.6824C6.38253 20.5264 7.52712 21.0005 8.7206 21.0005C9.91407 21.0005 11.0587 20.5264 11.9026 19.6824L19.595 12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AttachmentIcon;
